import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  IconButton,
  DialogActions,
  Pagination,
} from "@mui/material";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { api_base } from "../../env";
export default function Hashtags({ open, onClose, addHashTages }) {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [hashtags, setHashtags] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // Fetch categories
  useEffect(() => {
    axios
      .get(`${api_base}CategoryHasTagsRoute/getAll`)
      .then((response) => setCategories(response.data))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  // Fetch hashtags when a category is selected
  useEffect(() => {
    if (selectedCategory) {
      axios
        .get(`${api_base}HashTagsRoute/getByCategory/${selectedCategory.id}`, {
          params: {
            page: page,
          },
        })
        .then((response) => {
          setHashtags(response.data.data);
          setTotalPages(response.data.totalPages);
        })
        .catch((error) => console.error("Error fetching hashtags:", error));
    }
  }, [selectedCategory, page]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{ textAlign: "center" }}
    >
      <DialogTitle>
        {!selectedCategory ? (
          <Typography variant="h6">Select a Category</Typography>
        ) : (
          <Typography variant="h6">
            <IconButton onClick={() => setSelectedCategory(null)}>
              <ArrowBackIcon sx={{ verticalAlign: "middle", mr: 1 }} />
            </IconButton>
            Select a Hashtag
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        {!selectedCategory ? (
          <>
            <Grid container spacing={2}>
              {categories.map((category) => (
                <Grid item key={category.id} xs={12}>
                  <Card
                    onClick={() => setSelectedCategory(category)}
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={`${api_base}static/${category.urlImage}`}
                      alt={category.name}
                      sx={{
                        width: 100,
                        height: 100,
                        objectFit: "cover",
                      }}
                    />
                    <CardContent>
                      <Typography variant="h6">{category.name}</Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </>
        ) : (
          <>
            <Grid
              container
              spacing={2}
              sx={{ maxHeight: "60vh", overflowY: "auto" }}
            >
              {hashtags.map((tag) => (
                <Grid item key={tag.id}>
                  <Card
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "4px 8px",
                      minWidth: "auto",
                      width: "fit-content",
                      borderRadius: "12px",
                      backgroundColor: "#f5f5f5",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      addHashTages(tag.text);
                      onClose();
                    }}
                  >
                    <Typography variant="body2">{tag.text}</Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </DialogContent>
      {selectedCategory && (
        <DialogActions sx={{ justifyContent: "center" }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            siblingCount={0}
            boundaryCount={0}
          />
        </DialogActions>
      )}
    </Dialog>
  );
}
